export default {

	props: ['value', 'expand', 'errored', 'placeholder', 'label', 'note', 'slim'],

	methods: {

		onValueChange: function(value) {

			this.$emit('input', value)

		}

	}

}